import { TableRow, TableCell } from '@material-ui/core';

export default function RowNoData() {
  return (
    <TableRow style={{ height: '80px' }}>
      <TableCell colSpan={10}>
        <h3>Sem resultados</h3>
        {/* <Box width="100%">Sem resultados</Box> */}
      </TableCell>
    </TableRow>
  )
}
